import React from "react";

const UserContext = React.createContext(null);
const LoginContext = React.createContext(null);

export { UserContext, LoginContext };
